var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "minus-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 47"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#F40600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3",
    d: "M7 0C5.14348 -2.21387e-08 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 1.62302e-07 5.14348 0 7C-1.62302e-07 8.85651 0.737497 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14L7 7L7 0Z",
    fill: "#FFA500"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7H3.5Z",
    fill: "#ED2893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7H3.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircle);
export default __webpack_public_path__ + "static/media/minus-circle.6a9ebcd639b09d7945bdb6a3b759ec79.svg";
export { ForwardRef as ReactComponent };